import React, { useState, useEffect } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import {
  Main,
  About,
  Timeline,
  Expertise,
  Certifications,
  Portfolio,
  Services,
  Testimonial,
  Contact,
  Navigation,
  Footer,
} from "./components";
import FadeIn from './components/FadeIn';
import ProjectDetail from './pages/ProjectDetail';
import './index.scss';

function HomePage({ mode, handleModeChange }: { mode: string; handleModeChange: () => void }) {
  return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
      <Navigation parentToChild={{ mode }} modeChange={handleModeChange} />
      <FadeIn transitionDuration={500}>
        <Main />
        <About />
        <Services />
        <Portfolio />
        <Expertise />
        <Certifications />
        <Timeline />
        <Testimonial />
        <Contact />
      </FadeIn>
      <Footer />
    </div>
  );
}

function ProjectPage({ mode }: { mode: string }) {
  return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
      <ProjectDetail />
    </div>
  );
}

function App() {
  const [mode, setMode] = useState<string>('dark');

  const handleModeChange = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomePage mode={mode} handleModeChange={handleModeChange} />} />
        <Route path="/project/:slug" element={<ProjectPage mode={mode} />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
